
var desEl = $('.collection-header .description')
var toggleEl = $('.toggle-read-more')
    
if(desEl && desEl.length > 0) {

    var contentHeight = desEl[0].scrollHeight;
    var maxHeight = parseInt(desEl.css('max-height'))

    if(contentHeight > (maxHeight + 3)) {
      toggleEl.on('click', function(e) {
        e.preventDefault()
        var mode = toggleEl.attr('toggle-mode')
        if(mode == "expand") {
          desEl.addClass('expanded')
          toggleEl.text('Read less...')
          toggleEl.attr('toggle-mode', 'hide')
        } else {
          desEl.removeClass('expanded')
          toggleEl.text('Read more...')
          toggleEl.attr('toggle-mode', 'expand')
        }
      })
      toggleEl.show()
    } else {
      toggleEl.hide()
    }
} else {
    toggleEl.hide()
}